import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { MutliselectEnhancementComponent } from './mutliselect-enhancement.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SelectDropDownModule,
  ],
  exports: [
    MutliselectEnhancementComponent
  ],
  declarations: [MutliselectEnhancementComponent]
})
export class MutliselectEnhancementModule { }
